import React from "react";
import { FiLogOut } from "react-icons/fi";
import { Navigate, Link, useNavigate } from "react-router-dom";

export default function Protected({ children }) {
  const token = localStorage.getItem("auth-token");
  const navigate = useNavigate();
  if (!token) {
    return <Navigate to="/login" />;
  }

  return (
    <div style={containerStyle}>
      {/* Navbar */}
      <nav style={navbarStyle}>
        <ul style={navListStyle}>
          <li style={navItemStyle}>
            <Link 
              to="/all-messages" 
              style={{
                ...linkStyle,
                backgroundColor: window.location.pathname === '/all-messages' ? 'white' : 'transparent',
                color: window.location.pathname === '/all-messages' ? 'green' : 'white',
                padding: '5px 10px',
                borderRadius: '4px'
              }}
            >
              All Treads
            </Link>
          </li>
          <li style={navItemStyle}>
            <Link
              to="/all-reviews"
              style={{
                ...linkStyle,
                backgroundColor: window.location.pathname === '/all-reviews' ? 'white' : 'transparent', 
                color: window.location.pathname === '/all-reviews' ? 'green' : 'white',
                padding: '5px 10px',
                borderRadius: '4px'
              }}
            >
              All Reviews
            </Link>
            
          </li>
          <li style={{...navItemStyle, display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '2rem'}}>
            <FiLogOut onClick={() => {
              localStorage.removeItem("auth-token");
              navigate("/login");
            }} style={{cursor: 'pointer', fontSize: '1.5rem'}}/>
          </li>
        </ul>
      </nav>

      <div style={contentStyle}>{children}</div>
    </div>
  );
}

// Inline styles
const containerStyle = {
  display: "flex",
  flexDirection: "column",
  height: "100vh", // Full viewport height
};

const navbarStyle = {
  flexShrink: 0, // Prevent navbar from shrinking
  padding: "10px",
  backgroundColor: "green",
  color: "white",
  height: '70px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'right'
};

const navListStyle = {
  listStyle: "none",
  display: "flex",
  gap: "20px",
  margin: 0,
  padding: 0,
  alignItems: 'center',
  justifyContent: "right",
};

const navItemStyle = {
  margin: 0,
};

const linkStyle = {
  color: "white",
  textDecoration: "none",
  fontSize: "18px",
};

const contentStyle = {
  overflowY: "auto", // Enable vertical scrolling
  backgroundColor: "#f9f9f9",
  padding: 0,
  margin: 0,
};
